import { Shimmer } from "components/shimmer";
import React from "react";

export function AnalyticsStatsCardPlaceholder() {
  return (
    <div className="w-52 flex flex-col gap-2 ">
      <div className="flex justify-between text-sm font-medium text-muted-foreground">
        <Shimmer className="w-24 h-4" />
        <Shimmer className="w-10 h-4" />
      </div>
      <Shimmer className="w-32 h-8 md:h-10" />
    </div>
  );
}
